import React, { useState } from 'react';
import { List, ListItem, SearchBox, Text, TextHeadingTwo } from '@cko/primitives';
import { MicroFrontendConfig } from '@cko/dashboard-shared';

import { useDeveloperToolsProvider } from '../../../../context';
import { MFE_CONFIG } from '../../../../../environment/mfe';
import { filterBySearch } from '../utils';
import { MFEConfigEditor } from './MFEConfigEditor';

export const MfeEntriesPanel = () => {
  const { overrides, setOverrides, showOverridesOnly } = useDeveloperToolsProvider();
  const [searchString, setSearchString] = useState<string | undefined>('');

  const mfeConfigs = filterBySearch(
    showOverridesOnly
      ? overrides.mfeEntries
      : { ...MFE_CONFIG.microFrontendConfigs, ...overrides.mfeEntries },
    searchString,
  );
  const microFrontends = Object.keys(mfeConfigs);

  const updateConfig = (mfe: string, newConfig: MicroFrontendConfig) => {
    setOverrides({ ...overrides, mfeEntries: { ...overrides.mfeEntries, [mfe]: newConfig } });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--layout-soybean)' }}>
      <TextHeadingTwo>Micro Frontends</TextHeadingTwo>
      <Text>Refresh the page after making changes for the new config to reflect.</Text>
      <div style={{ width: '400px' }}>
        <SearchBox
          aria-label="Search"
          placeholder="Search for a microfrontend"
          onChange={setSearchString}
          onClear={() => setSearchString(undefined)}
          onSearch={() => {}}
        />
      </div>

      <List style={{ height: '400px', overflowY: 'scroll' }}>
        {microFrontends.map((microFrontend: string) => {
          return (
            <ListItem key={microFrontend}>
              <MFEConfigEditor
                value={mfeConfigs[microFrontend]}
                name={microFrontend}
                onChange={(newConfig: MicroFrontendConfig) =>
                  updateConfig(microFrontend, newConfig)
                }
                valueOverridden={microFrontend in overrides.mfeEntries}
              />
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};
